/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { getCurrentSubcategory } from 'owa-options-store';
import { lazyConfirmOptionNavigation, isAnyOptionDirty, shouldDisableSaveButton, } from 'owa-options-core';
import { saveOptions, discardOptions } from 'owa-options-orchestration';
var executeCallbackAndHide = orchestratorAction('executeCallbackAndHide', function executeCallbackAndHide(saveDiscardCallback, continueAfterConfirmCallback) {
    if (saveDiscardCallback) {
        saveDiscardCallback();
    }
    continueAfterConfirmCallback();
});
export default orchestratorAction('confirmDirtyOptionsAndPerformAction', function hideFullOptions(continueAfterConfirmCallback, continueAfterCancelCallback) {
    var currentSubcategory = getCurrentSubcategory();
    if (isAnyOptionDirty(currentSubcategory)) {
        lazyConfirmOptionNavigation.importAndExecute({
            onSave: function () {
                executeCallbackAndHide(saveOptions, continueAfterConfirmCallback);
            },
            onDiscard: function () {
                executeCallbackAndHide(discardOptions, continueAfterConfirmCallback);
            },
            onCancel: continueAfterCancelCallback,
            shouldDisableSaveButton: shouldDisableSaveButton(currentSubcategory),
        });
    }
    else {
        continueAfterConfirmCallback();
    }
});
//# sourceMappingURL=confirmDirtyOptionsAndPerformAction.js.map